<template>
  <v-layout class="timetable">
    <v-flex xs12 timetable-action-btn>
      <v-layout wrap class="float-right ">
        <v-edit-dialog :disabled="!editable" title="edit" dark class="display-1 pa-1 pr-5"
                       style="border-bottom: 1px solid white; margin-top: -15px;"> {{ timetableName}}
          <v-text-field
                  slot="input"
                  :value="timetableName"
                  @change="$emit('update:timetableName', $event)">
          </v-text-field>
        </v-edit-dialog>
        <v-btn v-if="editable && active" color="green" outline :disabled="!active"
               @click="$emit('update:active', false)"
               title="set inactive">Active
        </v-btn>
        <v-btn v-if="editable && !active" color="default" :disabled="active" @click="$emit('update:active', true)"
               title="activate">
          Hidden
        </v-btn>

      </v-layout>
    </v-flex>
    <v-layout timetable-body>
      <v-flex xs1 pr-3 first-column style="width: 45px; max-width: 55px;" class="time">
        <v-layout wrap>
          <v-flex xs12 class="text-xs-center">Time</v-flex>
          <v-flex xs12 class="invisible pt-3"> Halle</v-flex>
          <v-flex xs12 v-for="(time, tIndex) in times" :key="times[tIndex]" class="pa-1 border-bottom-03 grey--text"
                  :class="tIndex % 2 ? 'text--darken-3' : 'text--lighten-3'">{{time}}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout table-main style="overflow: auto">
          <v-flex class="days" v-for="(day, dIndex) in days" :key="days[dIndex]">
            <v-layout wrap>
              <v-flex xs12 dayHeader class="text-xs-center border-right-1"> {{day}}</v-flex>
              <v-flex xs12 rinkHeader halle>
                <v-layout wrap pt-3>
                  <v-flex xs6 class="text-xs-center grey--text lighten-1">H1</v-flex>
                  <v-flex xs6 class="text-xs-center blue-grey--text">H2</v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pr-2 body-rows v-for="(time, tIndex) in times" :key="times[tIndex]"
                      :class="tIndex % 2 ? ' grey darken-3' : 'grey darken-2'">
                <v-layout wrap>
                  <v-flex xs6 pr-1 v-for="rink in 2" :key="rink.index">
                    <div>
                      <v-layout>
                        <v-flex xs9 time-field>
                          <input v-if="!itemSet(dIndex, tIndex, rink)" class="pa-1 border-bottom table-input-field"
                                 :class="editable ? 'table-hover' : ''"
                                 type="text"
                                 :disabled="!editable"
                                 @click="editable ? $emit('activateNewDiv', dIndex, tIndex, rink, timetableId) : ''"
                                 :title="editable ? 'select time' : ''">
                          <div v-else="" class="pt-1">
                          <span
                                  @click="editable ? $emit('activateDiv', $event,itemSet(dIndex, tIndex, rink)) : ''"
                                  class="caption-2">{{itemSet(dIndex, tIndex, rink).timeStart}} - {{itemSet(dIndex, tIndex, rink).timeEnd}}</span>
                          </div>
                        </v-flex>
                        <v-flex xs3 category-field>
                          <div v-if="itemSet(dIndex, tIndex, rink)" class="pt-1 ml-1 circle elevation-10"
                               title="choose category"
                               @click="activateCat(dIndex, tIndex, rink)"
                               v-html="transformCat(itemSet(dIndex, tIndex, rink).category)">
                          </div>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-flex xs12 grey darken-2 pa-3 elevation-10>
      <div v-html="info" class="white--text"></div>
    </v-flex>
  </v-layout>
</template>
<script>


    export default {
        name: 'timetable',
        props: {
            times: {
                type: Array,
                validator: (val) => val.findIndex(item => typeof item !== 'string') < 0
            },
            days: {
                type: Array,
                validator: (val) => val.findIndex(item => typeof item !== 'string') < 0
            },
            groups: {
                type: Array,
                validator: (val) => val.findIndex(item => typeof item !== 'string') < 0
            },
            timeObj: {
                type: Object
            },
            timetableName: {type: String},
            timetableId: {type: Number},
            active: {type: Boolean},
            editable: {type: Boolean},
            info: {type: String}
        },
        data() {
            return {
                success: false,
                showCatPicker: false,
                activeCat: [],
                activeCatTimeObj: false
            }
        },
        methods: {
            itemSet(dIndex, tIndex, rink) {
                if (this.timeObj) {
                    return this.timeObj[dIndex] ? this.timeObj[dIndex][tIndex] ? this.timeObj[dIndex][tIndex][rink] : false : false
                }
            },
            activateCat(dIndex, tIndex, rink) {
                this.showCatPicker = true;
                this.activeCat = [dIndex, tIndex, rink];
                this.activeCatTimeObj = this.timeObj[dIndex][tIndex][rink];
            },
            saveCat(arr) {
                this.showCatPicker = false;
                let timeObj = this.itemSet(this.activeCat[0], this.activeCat[1], this.activeCat[2]);
                this.$emit('setCat', arr, timeObj)
            },
            cancel() {
                this.showCatPicker = false;
            },
            transformCat(cat) {
                let container = {innerText: '', classes: '', sub: '', f: ''};


                if (typeof cat === 'string' && cat.length > 23) {
                    cat = JSON.parse(cat)
                    //  let groups = ['F1', 'F2', 'F3', 'F4', 'F5', 'E', 'Ju','Privat', 'Fö','N', 'N*']
                } else if (cat.length !== 12) {
                    return `<div class="cat yellow grey--text text--darken-3">N*<div class="f"></div><div class="subs"></div> </div>`
                }
                if (cat[10]) {
                    container.innerText = 'N*'
                    container.classes = 'yellow grey--text text--darken-3'
                } else if (cat[5]) {
                    container.innerText = 'E'
                    container.classes = 'red'
                } else if (cat[11]==0) {
                    container.innerText = 'X'
                    container.classes = 'black black--text'
                } else {
                    let start = cat.findIndex(i => i === 1);
                    let end = 4 - [...cat].splice(0, 5).reverse().findIndex(i => i === 1);
                    switch (end+1) {
                        case 1:
                            container.classes = 'pink';
                            break;
                        case 2:
                            container.classes = 'orange';
                            break;
                        case 3:
                            container.classes = 'purple';
                            break;
                        case 4:
                            container.classes = 'deep-purple';
                            break;
                        default:
                            container.classes = 'green';
                            break;
                    }
                    container.innerText = 'F';
                    if (start !== end)
                        container.f += start+1 + '-' + (end+1);
                    else
                        container.f += start+1
                }
                if (cat[9]) container.sub += '<span class="foe yellow grey--text text--darken-3">N</span>';
                if (cat[6]) container.sub += '<span class="ju amber grey--text text--darken-3">Ju</span>';
                if (cat[7]) container.sub += '<span class="p light-blue darken-2">P</span>';
                if (cat[8]) container.sub += '<span class="foe grey white--text darken-4 pr-1">Fö</span>';


                return `<div class='cat ${container.classes}'>${container.innerText}<div class="f">${container.f}</div><div class="subs">${container.sub}</div> </div>`
            },

        }
    }

</script>
<style lang="scss">

  .cat {
    position: relative;
    background: red;
    border-radius: 50%;
    text-align: center;
    box-shadow: inset 0 0 2px #000000b3;
    cursor: pointer;

    .f {
      position: absolute;
      font-size: 7pt;
      top: -8px;
      right: -13px;
      background: #ffffff9e;
      color: black;
      padding: 0 4px;
      box-shadow: inset 0 0 4px rgba(44, 44, 44, 0.7);
      border-radius: 2px;
    }
    .subs {
      position: absolute;
      margin-top: -7px;
      padding-left: 5px;
      > span {
        padding: 1px 2.5px;
        font-size: 6pt;
        margin-left: 2px;
        border-radius: 3px;
        box-shadow: inset 0 0 1px rgba(44, 44, 44, 0.7), 0 0 3px black;
        &.grey{
          box-shadow:  1px 0 1px #8d8d8d;
          padding: 2px;
        }
        &.light-blue{
          text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.7);
        }

      }
    }

  }

  #app > div.v-menu__content.menuable__content__active.v-small-dialog__content > div > div > div > div.v-input__slot > div > input[type="text"] {
    color: black;
  }

  #app > div.v-menu__content.menuable__content__active.v-small-dialog__content > div > div > div > div.v-input__slot::before {
    border-color: rgba(137, 138, 139, 0.7);
  }
</style>
